import { Product as ProductTileProduct } from '@spa/components/product-list/product-tile/product-tile.component';
import calculatePriceValues from '@spa/lib/getPriceValues';
import { getProductImageOrFallback } from '@spa/lib/getProductImageOrFallback';

export interface StructuredDataSourceProduct extends Pick<
  ProductTileProduct,
  'name' | 'path' | 'image' | 'assets' | 'currentPrice'
> {}

export interface StructuredProductOffer {
  readonly priceCurrency: string;
  readonly price: number;
}

export interface StructuredProduct {
  readonly name: string;
  readonly url: string;
  readonly image?: string[];
  readonly offers?: StructuredProductOffer;
}

export function buildStructuredProductData(
  products: ReadonlyArray<StructuredDataSourceProduct>,
  publicBaseUrl: string,
  pricesIncludeTax: boolean,
  suppressPriceData: boolean = false
): StructuredProduct[] {
  return products.map((p) => {
    const img = getProductImageOrFallback(p.image, p.assets ?? null);

    return {
      name: p.name,
      url: `${publicBaseUrl}${p.path}`,
      image: img?.url ? [img.url] : undefined,
      offers: suppressPriceData
        ? undefined
        : {
            priceCurrency: p.currentPrice.currencyIso,
            price: calculatePriceValues(pricesIncludeTax, {
              currentPrice: p.currentPrice
            }).currentPriceValue
          }
    };
  });
}

export default buildStructuredProductData;
